import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

const stories = [
  {
    eyebrow: "Écoles africaines",
    title: "Une gestion scolaire pensée pour les réalités du terrain.",
    text:
      "Des classes chargées, des parents mobiles, des frais à suivre et des bulletins à communiquer: EviveSoma rassemble les informations essentielles dans un espace clair.",
    image:
      "https://images.unsplash.com/photo-1632215861513-130b66fe97f4?auto=format&fit=crop&w=1400&q=80",
    isBlackWhite: true,
    meta: "Direction, secrétariat, enseignants",
  },
  {
    eyebrow: "Salle de classe",
    title: "Les enseignants gardent une trace claire du parcours des élèves.",
    text:
      "Présences, notes, discipline et appréciations peuvent être centralisées pour aider chaque enseignant à suivre sa classe avec plus de précision.",
    image:
      "https://images.unsplash.com/photo-1744809482817-9a9d4fc280af?auto=format&fit=crop&w=1400&q=80",
    meta: "Présence, évaluation, discipline",
  },
  {
    eyebrow: "Élèves",
    title: "Les bulletins et résultats deviennent accessibles plus rapidement.",
    text:
      "Les familles n'ont plus besoin d'attendre longtemps pour comprendre le niveau, les progrès et les besoins de leurs enfants.",
    image:
      "https://images.unsplash.com/photo-1666281269793-da06484657e8?auto=format&fit=crop&w=1400&q=80",
    isBlackWhite: true,
    meta: "Annonces, alertes, accompagnement",
  },
  {
    eyebrow: "Parents et communauté",
    title: "Le lien avec l'école reste vivant, même à distance.",
    text:
      "Réunions, rappels de paiement, résultats et informations urgentes peuvent être partagés rapidement avec les responsables.",
    image:
      "https://images.unsplash.com/photo-1772562179599-f4137b8f18ac?auto=format&fit=crop&w=1400&q=80",
    meta: "Familles, responsables, éducateurs",
  },
  {
    eyebrow: "École congolaise",
    title: "Un outil simple pour accompagner les établissements locaux.",
    text:
      "De Kinshasa à Lubumbashi, Goma ou Matadi, etc. EviveSoma aide les écoles à mieux organiser les dossiers, les paiements et la communication.",
    image:
      "https://images.unsplash.com/photo-1770843093640-c44ae557928b?auto=format&fit=crop&w=1400&q=80",
    meta: "Kinshasa, Lubumbashi, Goma, Bukavu, Matadi etc.",
  },
];

class SchoolStoriesSlider extends Component {
  state = {
    activeStory: 0,
  };

  componentDidMount() {
    this.storyTimer = window.setInterval(this.showNextStory, 7000);
  }

  componentWillUnmount() {
    window.clearInterval(this.storyTimer);
  }

  setStory = (activeStory) => {
    window.clearInterval(this.storyTimer);
    this.setState({ activeStory });
    this.storyTimer = window.setInterval(this.showNextStory, 7000);
  };

  showNextStory = () => {
    this.setState((state) => ({
      activeStory: (state.activeStory + 1) % stories.length,
    }));
  };

  showPreviousStory = () => {
    this.setState((state) => ({
      activeStory: (state.activeStory - 1 + stories.length) % stories.length,
    }));
  };

  render() {
    const story = stories[this.state.activeStory];

    return (
      <section className="school-stories-section" id="ecoles">
        <div className="container">
          <div className="school-stories-panel">
            <div
              className={`school-stories-image${story.isBlackWhite ? " school-stories-image-black-white" : ""}`}
              key={`story-image-${this.state.activeStory}`}
            >
              <img src={story.image} alt={story.title} loading="lazy" />
            </div>

            <div className="school-stories-copy" key={`story-copy-${this.state.activeStory}`}>
              <span className="landing-eyebrow">{story.eyebrow}</span>
              <h2>{story.title}</h2>
              <p>{story.text}</p>
              <div className="school-stories-meta">
                <FeatherIcon icon="map-pin" size={17} />
                <span>{story.meta}</span>
              </div>

              <div className="school-stories-controls" aria-label="Navigation des histoires">
                <button type="button" onClick={this.showPreviousStory} aria-label="Histoire précédente">
                  <FeatherIcon icon="chevron-left" size={18} />
                </button>
                <div>
                  {stories.map((item, index) => (
                    <button
                      key={item.title}
                      type="button"
                      className={index === this.state.activeStory ? "active" : ""}
                      onClick={() => this.setStory(index)}
                      aria-label={`Afficher l'histoire ${index + 1}`}
                    />
                  ))}
                </div>
                <button type="button" onClick={this.showNextStory} aria-label="Histoire suivante">
                  <FeatherIcon icon="chevron-right" size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SchoolStoriesSlider;
